import React, { Component } from 'react';

export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    
    return (
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/profilepic.jpg" alt="Omar Ghamrawi Profile" />
          </div>

          <div className="nine columns main-col">
            <h2>About Me</h2>
            <p style={{ marginBottom: '20px' }}>
              {resumeData.aboutme.split('\n').map((line, idx) => (
                <React.Fragment key={idx}>
                  {line}
                  {idx < resumeData.aboutme.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>

            <div className="row">
              <div className="columns contact-details">
                <p className="address">
                  <span>{resumeData.address}</span><br />
                  <span>{resumeData.email}</span><br />
                  <span>Languages: Arabic (Native), English (Fluent), Turkish & French (Professional)</span>
                  {resumeData.website && (
                    <>
                      <br />
                      <span>{resumeData.website}</span>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}